import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  imports: [],
  template: ` <footer><ng-content></ng-content></footer> `,
  styles: `
    :host {
      display: block;
      color: var(--base-text-color-alpha-7);
      border-top: 1px solid var(--footer-border-color);
      padding-top: 20px;
      padding-bottom: 24px;
      margin: 0 40px;

      .screen-x-small & {
        margin: 0 20px;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class Footer {}
